export default __webpack_public_path__ + "static/media/serata-hawaii-logo.e65c5a94.svg";